import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/category.module.css';

function CategoryTypography({ className = null, ...props }: TypographyProps) {
    return <Typography className={classNames([styles.container, className])} {...props} />;
}

export default CategoryTypography;
